import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import baseUrl from "../../url/baseUrl";

const sections = [
  { prize: "Balo Mễ Mễ" },
  { prize: "Túi vải đay" },
  { prize: "Balo khủng long" },
  { prize: "Mãy lọc không khí mini" },
  { prize: "Túi vải bỉm sữa" },
  { prize: "Bộ 6 cốc thủy tinh Mễ Mễ" },
  { prize: "Balo tiên cá" },
  { prize: "Quạt tích điện cầm tay" },
  { prize: "Mũ cờ đỏ sao vàng" },
  { prize: "Yếm silicon" },
  { prize: "Nhiệt kế hồng ngoại" },
  { prize: "Tất tập bò cho bé" },
  { prize: "Hộp bút chì hoạt hình" },
  { prize: "Dụng cụ uống thuốc cho bé" },
  { prize: "Ô trẻ em" },
];

const createEmptyQuantities = () => {
  return sections.reduce((acc, section) => {
    acc[section.prize] = "";
    return acc;
  }, {});
};

function PrizeQuantityForm() {
  const navigate = useNavigate();
  const [quantities, setQuantities] = useState(createEmptyQuantities);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    fetchCurrentQuantities();
  }, []);

  const fetchCurrentQuantities = async () => {
    try {
      setFetching(true);

      const response = await fetch(`${baseUrl}/api/prize-quantities`);

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không lấy được dữ liệu quà");
      }

      const currentQuantities = createEmptyQuantities();

      if (data.data && Array.isArray(data.data.prizes)) {
        data.data.prizes.forEach((item) => {
          currentQuantities[item.prize] = item.quantity;
        });
      }

      setQuantities(currentQuantities);
    } catch (error) {
      console.error(error);
      alert(error.message);
    } finally {
      setFetching(false);
    }
  };

  const handleChange = (prize, value) => {
    setQuantities((prev) => ({
      ...prev,
      [prize]: value,
    }));
  };

  const handleOk = async () => {
    const prizes = sections.map((section) => ({
      prize: section.prize,
      quantity: Number(quantities[section.prize]) || 0,
    }));

    try {
      setLoading(true);

      const response = await fetch(`${baseUrl}/api/prize-quantities`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ prizes }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Lưu số lượng quà thất bại");
      }

      alert("Lưu số lượng quà thành công!");

      if (data.data && Array.isArray(data.data.prizes)) {
        const updatedQuantities = createEmptyQuantities();

        data.data.prizes.forEach((item) => {
          updatedQuantities[item.prize] = item.quantity;
        });

        setQuantities(updatedQuantities);
      }
    } catch (error) {
      console.error(error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center ">
          <h5 className="mb-0 text-danger">Thiết lập số lượng phần quà</h5>

          <button
            className="btn btn-sm btn-outline-primary"
            onClick={fetchCurrentQuantities}
            disabled={fetching || loading}
          >
            {fetching ? "Đang tải..." : "Tải lại"}
          </button>
        </div>

        <div className="card-body">
          {fetching && (
            <div className="alert alert-info">
              Đang tải dữ liệu từ server...
            </div>
          )}

          <div className="row g-3 mb-1">
            {sections.map((section, index) => (
              <div className="col-12 col-md-6 col-lg-4" key={section.prize}>
                <label className="form-label fw-bold">
                  {index + 1}. {section.prize}
                </label>

                <input
                  type="number"
                  min="0"
                  className="form-control"
                  placeholder="Nhập số lượng"
                  value={quantities[section.prize]}
                  onChange={(e) => handleChange(section.prize, e.target.value)}
                  disabled={fetching || loading}
                />
              </div>
            ))}
          </div>

          <div className="card-footer d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => navigate("/lucky-wheel")}
              disabled={loading || fetching}
            >
              Cancel
            </button>

            <button
              className="btn btn-primary"
              onClick={handleOk}
              disabled={loading || fetching}
            >
              {loading ? "Đang lưu..." : "OK"}
            </button>
          </div>

          <hr className="my-4" />

          <h5 className="mb-3 text-danger">Bảng số lượng quà hiện có</h5>

          <div className="table-responsive">
            <table className="table table-bordered table-striped align-middle">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "80px" }}>STT</th>
                  <th>Tên phần quà</th>
                  <th style={{ width: "180px" }}>Số lượng hiện có</th>
                </tr>
              </thead>

              <tbody>
                {sections.map((section, index) => (
                  <tr key={section.prize}>
                    <td>{index + 1}</td>
                    <td>{section.prize}</td>
                    <td>{Number(quantities[section.prize]) || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrizeQuantityForm;
